module.exports = __webpack_public_path__ + "img/goods1_5.531d2027.jpg";